import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { FeatureFlagsPage } from '@/areas/settings/Settings/FeatureFlagsPage/FeatureFlagsPage';
import { canViewFeatureFlagsSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/feature-flags')({
    staticData: { access: { permissions: canViewFeatureFlagsSettings }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <FeatureFlagsPage />;
}
